import cc from "classcat";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import TypeformLoader from "../TypeformLoader";
import CookieConsentContainer from "../CookieConsentContainer";
import ResponsiveController from "../../../../src/modules/_common/components/ResponsiveController";
import Header from "./Header";
import { BotOnButton } from "../../../../src/modules/_common/components/BotOnButton";
import { useEffect } from "react";
import { isAccentureBuild } from "../../helpers/utils";
import NotFoundPage from "../../pages/404";
import FooterSlim from "../FooterSlim";
import FooterAccenture from "../FooterAccenture";
import HeaderAccenture from "../HeaderAccenture";
import ExitPopup from "./ExitPopup";

const Document = ({
	children,
	title,
	className = "",
	programme = null,
	indexable = true,
	headerComponent = null,
	ogData = {},
	accentureAccessible = false,
	isNameFirst = false,
	showFooterNavigation = true,
	isOptimiseEnabled = false,
	showExitPopup = true,
	...props
}) => {
	useEffect(() => {
		if (typeof window !== "undefined") {
			if (window.location.hash.length === 0) {
				setTimeout(() => {
					window.scrollTo(0, -1);
				}, 10);
			}
		}
	}, []);

	if (!accentureAccessible && isAccentureBuild) {
		return <NotFoundPage />;
	}

	return (
		<div className="sn-v2-site">
			<ResponsiveController />
			{!isAccentureBuild ? <>{headerComponent !== null ? <>{headerComponent}</> : <Header />}</> : <HeaderAccenture />}
			<main
				id="wrapper"
				className={cc([
					className,
					{
						[`programme-${programme} programme-lp`]: programme != null,
						acn: isAccentureBuild,
					},
				])}
				data-programme={programme}
				{...props}
			>
				<Helmet
					htmlAttributes={{
						lang: "en",
					}}
				>
					{!indexable && <meta name="robots" content="noindex,follow" />}
					<link
						rel="apple-touch-icon"
						sizes="180x180"
						href="https://staynimble-front-endprod.s3.eu-west-2.amazonaws.com/apple-touch-icon.png"
					/>
					<link
						rel="icon"
						type="image/png"
						sizes="32x32"
						href="https://staynimble-front-endprod.s3.eu-west-2.amazonaws.com/favicon-32x32.png"
					/>
					<link
						rel="icon"
						type="image/png"
						sizes="16x16"
						href="httugps://staynimble-front-endprod.s3.eu-west-2.amazonaws.com/favicon-16x16.png"
					/>
					<link rel="manifest" href="https://staynimble-front-endprod.s3.eu-west-2.amazonaws.com/site.webmanifest" />
					<link
						rel="mask-icon"
						href="https://staynimble-front-endprod.s3.eu-west-2.amazonaws.com/safari-pinned-tab.svg"
						color="#5bbad5"
					/>
					<meta name="msapplication-TileColor" content="#da532c" />
					<meta name="theme-color" content="#ffffff" />
					<meta name="google-site-verification" content="f_L3D9P7_N1DD0_AfPjHYleMZJRB3Q0fJ4BMU7peu8o" />
					<meta
						name="msapplication-config"
						content="https://staynimble-front-endprod.s3.eu-west-2.amazonaws.com/browserconfig.xml"
					/>
					<title>{isNameFirst ? `Stay Nimble | ${title}` : `${title} | Stay Nimble`}</title>
					<meta property="og:locale" content="en_GB" />
					<meta property="og:site_name" content="Stay Nimble" />
					<meta property="og:title" content={title} />
					<meta property="fb:app_id" content="440825303709219" />
					{ogData.url && <meta property="og:url" content={process.env.GATSBY_SITE_URL + ogData.url} />}
					<meta property="og:type" content={ogData.article ? "article" : "website"} />
					{ogData.description && <meta name="description" content={ogData.description} />}
					{ogData.description && <meta property="og:description" content={ogData.description} />}
					{ogData.description && <meta name="twitter:description" content={ogData.description} />}
					{ogData.image && (
						<meta
							property="og:image"
							content={ogData.image.match(/^http[s]?.+/) ? ogData.image : process.env.GATSBY_SITE_URL + ogData.image}
						/>
					)}
					{ogData.image && (
						<meta
							name="image"
							content={ogData.image.match(/^http[s]?.+/) ? ogData.image : process.env.GATSBY_SITE_URL + ogData.image}
						/>
					)}
					{ogData.image && (
						<meta
							name="twitter:image"
							content={ogData.image.match(/^http[s]?.+/) ? ogData.image : process.env.GATSBY_SITE_URL + ogData.image}
						/>
					)}
					<meta name="twitter:card" content="summary_large_image" />
					<meta name="twitter:site" content="@StayNimble" />
					<meta name="twitter:creator" content="@StayNimble" />
					<meta name="twitter:title" content={title} />
					{isOptimiseEnabled && <script src="https://www.googleoptimize.com/optimize.js?id=OPT-PNQJG9P"></script>}

					{/*GetResponse Analytics */}
					<script type="text/javascript">
						{`
						(function(m, o, n, t, e, r, _){
						m['__GetResponseAnalyticsObject'] = e;m[e] = m[e] || function() {(m[e].q = m[e].q || []).push(arguments)};
						r = o.createElement(n);_ = o.getElementsByTagName(n)[0];r.async = 1;r.src = t;r.setAttribute('crossorigin', 'use-credentials');_.parentNode .insertBefore(r, _);
					})(window, document, 'script', 'https://ga.getresponse.com/script/5ac3c68b-0aa7-4d2f-beba-7c30f7471dc7/ga.js', 'GrTracking');
						`}
					</script>
					{/* End GetResponse Analytics */}
				</Helmet>
				{children}
			</main>
			{!isAccentureBuild ? (
				<Footer showFooterNavigation={showFooterNavigation} />
			) : (
				<>
					<FooterAccenture />
					<FooterSlim />
				</>
			)}
			<TypeformLoader />
			<CookieConsentContainer />
			<BotOnButton id="get-in-touch" />
			{showExitPopup && <ExitPopup />}
		</div>
	);
};

export default Document;
